import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { useNavigate, useLocation } from "react-router-dom";
import { FaMosque } from 'react-icons/fa6';
import './Login.scss';

const Login = ({ setUser }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from || '/';

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-header">
                    <FaMosque className="login-logo" />
                    <h1>Welcome to Chorulla Palli </h1>
                    <p className="login-subtitle">Sign in to access additional features</p>
                </div>

                <div className="login-content">
                    <div className="login-benefits">
                        <h2>Why Sign In?</h2>
                        <ul>
                            <li>✓ Add new mosques to the directory</li>
                            <li>✓ Edit mosque information</li>
                            <li>✓ Contribute to the community</li>
                            <li>✓ Access exclusive features</li>
                        </ul>
                    </div>

                    <div className="login-button">
                        <GoogleLogin
                            onSuccess={(credentialResponse) => {
                                const decoded = jwtDecode(credentialResponse.credential);
                                localStorage.setItem("user", JSON.stringify(decoded));
                                // Dispatch custom event to notify Navbar of user update
                                window.dispatchEvent(new Event('userUpdated'));
                                // Redirect to the page user was trying to access, or home if no redirect
                                navigate(from !== '/' ? from : '/', { replace: true });
                            }}
                            onError={() => {
                                console.log("Login Failed");
                            }}
                            useOneTap
                            theme="outline"
                            shape="pill"
                            size="large"
                        />
                    </div>
                </div>

                <div className="login-footer">
                    <p>By signing in, you agree to our Terms of Service and Privacy Policy</p>
                </div>
            </div>
        </div>
    );
};

export default Login;